import React from "react";
import "../styles/Hamburger.css";

const Hamburger = ({ handleMobileNavToggle, isOpened, isMogomaPage }) => {
  return (
    <div className="hamburger-container" onClick={handleMobileNavToggle}>
      {!isOpened ? (
        <div className={`menu ${isMogomaPage ? "mogoma" : ""}`}>
          <span className="line-1"></span>
          <span className="line-2"></span>
          <span className="line-3"></span>
        </div>
      ) : (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          style={{ display: "block", margin: "auto" }}
        >
          <line
            x1="0"
            y1="0"
            x2="24"
            y2="24"
            stroke={isMogomaPage ? "black" : "white"}
            strokeWidth="3"
            strokeLinecap="round"
          />
          <line
            x1="24"
            y1="0"
            x2="0"
            y2="24"
            stroke={isMogomaPage ? "black" : "white"}
            strokeWidth="3"
            strokeLinecap="round"
          />
        </svg>
      )}
    </div>
  );
};

export default Hamburger;
